var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',{staticClass:"mt-2"},[_vm._v("Word Counter")]),_c('words')],1)}
var staticRenderFns = []

export { render, staticRenderFns }